import { createRoot } from 'react-dom/client';

import RoiCalculatorApp from './components/RoiCalculatorApp';

const selectBlocks = () =>
  Array.from(
    document.querySelectorAll<HTMLElement>('[data-roi-root="true"][data-hydrated="false"]'),
  );

const hydrateBlock = (root: HTMLElement) => {
  const heroTitle = root.dataset.heroTitle || 'Intranet ROI Calculator';
  const heroDescription = root.dataset.heroDescription || '';
  const hubspotEmbed = root.dataset.hubspotEmbed || '';
  const pricingPageUrl = root.dataset.pricingPageUrl || '/intranet-pricing/';

  root.innerHTML = '';

  const mount = createRoot(root);
  mount.render(
    <RoiCalculatorApp
      heroTitle={heroTitle}
      heroDescription={heroDescription}
      hubspotEmbed={hubspotEmbed}
      pricingPageUrl={pricingPageUrl}
    />,
  );

  root.dataset.hydrated = 'true';
};

const start = () => {
  const hydrate = () => {
    selectBlocks().forEach(hydrateBlock);
  };

  const observer = new MutationObserver(hydrate);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  hydrate();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
